// Get Shipping Code Random
export const GET_SHIPPING_CODE_RANDOM_REQUEST = 'GET_SHIPPING_CODE_RANDOM_REQUEST';
export const GET_SHIPPING_CODE_RANDOM_DONE = 'GET_SHIPPING_CODE_RANDOM_DONE';
export const GET_SHIPPING_CODE_RANDOM_FAILED = 'GET_SHIPPING_CODE_RANDOM_FAILED';
